export const statuses = {
  ERROR: "error",
  PROCESSING: "processing",
  SUBMIT: "submit",
  FREE_MINT: "freeMint",
  APPROVE: "approve"
};
